import Complement from "../composition/Complement"

export default class Counterweight extends Complement {
    static className = "Counterweight"
}